import { lumiApi } from "../index";

export const projectsApi = lumiApi.injectEndpoints({
    endpoints: (build) => ({
        getProjects: build.query({
            query: () => "projects",
            providesTags: () => [{ type: "Projects" }],
        }),
        getProjectById: build.query({
            query: (id) => `/projects/${id}`,
            providesTags: () => [{ type: "Project" }],
        }),
        getProjectMetaData: build.query({
            query: (id) => `/projects/${id}/metadata`,
        }),
        getUniqToFilter: build.query({
            query: (id) => `/projects/${id}/tab_data/unique_to_filter`,
            transformResponse(data) {
                return data.result;
            },
        }),
        getProjectDataByProjectId: build.mutation({
            query: (id) => ({
                url: `/projects/${id}/tab_data_get`,
                method: "POST",
            }),
            invalidatesTags: ["Projects"],
        }),
        exportResponses: build.mutation({
            query: ({ data, projectId, token }) => ({
                url: `projects/${projectId}/fetchdata`,
                method: "POST",
                body: { ...data, token },
            }),
            invalidatesTags: (result, error, arg) => [
                { type: "Tasks", id: arg.projectId },
            ],
        }),
        getTasksByProjectId: build.query({
            query: (projectId) => `projects/${projectId}/tasks`,
            providesTags: (result, error, arg) => [{ type: "Tasks", id: arg }],
        }),
    }),
});

export const {
    useGetProjectsQuery,
    useGetProjectByIdQuery,
    useExportResponsesMutation,
} = projectsApi;
